<template lang="pug">
#choose-biz
  NewBizDialog(v-model="newBizDialog")
  v-dialog(v-model="value", scrollable, persistent, max-width=640)
    v-card 
      v-card-title {{ $t('Menu.__ChangeBiz') }}
      //- v-card-subtitle.mt-1 You are not authorized to view this biz
      v-card-text
        v-list#user-menu-list
          v-list-item.biz-item(v-for="biz in $store.state.bizes.mybizes", @click="changeBiz(biz)", :key="biz.name")
            v-list-item-title
              .biz {{ biz.name }}
          v-list-item.biz-item.primary--text(@click="newBizDialog = true")
            v-list-item-avatar
              v-icon(color="primary") add
            v-list-item-title.primary--text {{ $t('MyBizes.__AddBiz') }}
</template>
<script>
import NewBizDialog from "@/components/dialogs/NewBizDialog"

export default {
  components: { NewBizDialog },

  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      mybizes: [],
      lastPage: "",
      newBizDialog: false
    }
  },
  methods: {
    changeBiz(biz) {
      this.$store.dispatch("bizes/updateBizInfo", biz)
      this.$store
        .dispatch("account/updateUsedBiz", biz.id)
        .then(function(response) {}.bind(this))
        .catch(function(error) {}.bind(this))
      this.$forceUpdate()

      location.href = "/" + this.$i18n.locale + "/dashboard"
    }
  },
  mounted() {}
}
</script>
